import { observer } from "mobx-react";
import { useStore } from "src/providers/store";
import AppBar from "src/components/AppBar";
import Loader from "../Loader";
import css from "./appContainer.module.scss";
import { useEffect } from "react";
import classNames from "classnames";
import {
  Home,
  Phone,
  Fax,
  AccessTime,
  YouTube,
  Email,
  VpnKey,
} from "@mui/icons-material";
import { Alert, Container, Link, Snackbar, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface AppContainerProps {
  showAppBar?: boolean;
  title?: string;
  className?: any;
  children: any;
  isLoading?: boolean;
  showUser?: boolean;
  showLang?: boolean;
  showFooter?: boolean;
  showAlert?: boolean;
  alertData?: any;
  onScrollAppContent?: () => void;
  refAppContent?: any;
}

const AppContainer = ({
  children,
  isLoading = false,
  showAppBar = false,
  showUser = false,
  showLang = false,
  showFooter = false,
  showAlert = false,
  alertData,
  title = "",
  className = "",
  onScrollAppContent,
  refAppContent,
}: AppContainerProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const store = useStore();
  const { app } = store;
  const appBarHeight = 76;

  const themeName = app.getTheme();
  const getThemeClassName = () => {
    let theme = "";
    switch (themeName) {
      case 1:
        theme = "default";
        break;
      case 2:
        theme = "bright-energy";
        break;
      case 3:
        theme = "chery-on-top";
        break;
      default:
        theme = "default";
        break;
    }

    return `theme-${theme}`;
  };

  useEffect(() => {
    const tags = document.getElementsByTagName("body");
    if (tags && tags.length) {
      const doc = tags[0];
      doc.className = getThemeClassName();
    }
  }, [themeName]);

  const handleCloseSnackbar = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === "clickaway") {
      return;
    }

    // setOpenSnackbar(false);
  };

  return (
    <div className={getThemeClassName()}>
      <Loader show={isLoading} />
      <div className={css.appBg} />
      <div className={`${css.appContainer} ${className}`}>
        {showAppBar && (
          <AppBar showUser={showUser} showLang={showLang}>
            {title}
          </AppBar>
        )}

        <div
          id="appContent"
          className={classNames(css.appContent)}
          style={{
            height: `calc(100vh - ${showAppBar ? appBarHeight : 0}px)`,
            marginTop: `${showAppBar ? appBarHeight : 0}px`,
          }}
          onScroll={onScrollAppContent}
          ref={refAppContent}
        >
          {children}
          <div className={css.footer}>
            {showFooter && (
              <div className={css.footerBody}>
                <Container>
                  <Typography variant="h6" className={css.topic}>
                    {t("contact")}
                  </Typography>
                  <Link
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/login")}
                  >
                    <div className={css.inline}>
                      <VpnKey className={css.icon} />
                      {t("login")}
                    </div>
                  </Link>

                  <div className={css.inline}>
                    <b>
                      ตรวจคนเข้าเมืองจังหวัดหนองคาย กองบังคับการตรวจคนเข้าเมือง
                    </b>
                  </div>
                  <div className={css.inline}>
                    <Home className={css.icon} />
                    106 ม.7 ต.มีชัย อ.เมืองหนองคาย จ.หนองคาย 43000
                  </div>
                  <div className={css.inline}>
                    <Phone className={css.icon} />0 4299 0935
                  </div>
                  <div className={css.inline}>
                    <Email className={css.icon} />
                    nongkhaiimmigration@gmail.com
                  </div>
                  {/* <div className={css.inline}>
                    <AccessTime className={css.icon} />
                    จันทร์ - ศุกร์, 06:30 - 22:00 น.
                  </div> */}
                </Container>
              </div>
            )}
            <div className={css.footerBottom}>
              <Container className={css.flex}>
                <div>
                  COPYRIGHT 2020 กองบังคับการตรวจคนเข้าเมือง |
                  ALL RIGHTS RESERVED
                </div>
                <div className={css.flexRight}>
                  <Link
                    target={"_blank"}
                    href="https://www.youtube.com/watch?v=NDBR4exSW98&ab_channel=ALAMAXOfficial"
                  >
                    <YouTube className={css.iconYoutube} />
                  </Link>
                  <Link
                    target={"_blank"}
                    href="http://mail.immigration.go.th/roundcube/"
                  >
                    <Email className={css.iconEmail} />
                  </Link>
                </div>
              </Container>
            </div>
          </div>
        </div>
      </div>
      {showAlert && (
        <Snackbar
          open={showAlert}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          autoHideDuration={5000}
          onClose={handleCloseSnackbar}
        >
          <Alert
            onClose={handleCloseSnackbar}
            variant="filled"
            severity={alertData.severity === "success" ? "success" : "error"}
            sx={{ width: "100%" }}
          >
            {alertData.message}
          </Alert>
        </Snackbar>
      )}
    </div>
  );
};

export default observer(AppContainer);
